import { render, staticRenderFns } from "./EffectFeedbackModal.vue?vue&type=template&id=fff45470&scoped=true"
import script from "./EffectFeedbackModal.vue?vue&type=script&lang=js"
export * from "./EffectFeedbackModal.vue?vue&type=script&lang=js"
import style0 from "./EffectFeedbackModal.vue?vue&type=style&index=0&id=fff45470&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff45470",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fff45470')) {
      api.createRecord('fff45470', component.options)
    } else {
      api.reload('fff45470', component.options)
    }
    module.hot.accept("./EffectFeedbackModal.vue?vue&type=template&id=fff45470&scoped=true", function () {
      api.rerender('fff45470', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/mentalHealth/CrisisIntervent/components/EffectFeedbackModal.vue"
export default component.exports